<template>
  <v-layout :class="[{ deprecated: !isCurrentEdition }]">
    <MainMenu />
    <v-flex>
      <v-layout
        v-if="showPageLoader"
        row
        fill-height
        align-center
        justify-center
      >
        <PageLoader />
      </v-layout>
      <v-layout
        v-else
        column
        fill-height
      >
        <listPagesHeader
          :page-title="pageTitle"
          :show-btn="false"
          class="none-growth"
        />
        <v-layout
          class="page-content-paddings"
          wrap
        >
          <v-flex
            v-if="family !== null"
            xs12
          >
            <v-flex
              x12
              class="lh-1 mt-3"
            >
              <a
                class="link_iconed lh-1"
                :class="{ link_deprecated: !isCurrentEdition }"
                @click="forward()"
              >
                <v-icon>chevron_left</v-icon>
                {{ $t('buttons.return_to_families_list') }}
              </a>
            </v-flex>
            <v-flex
              xs12
              class="mt-2"
              :class="[{ deprecated: deprecatedTurnOffBox }]"
            >
              <previousEditionDuplicateAlert
                :visible="previousEditionsAlertVisibility"
                :full-name="fullName"
              />
              <turnOffAlert
                v-if="showTurnOff || showTurnOn"
                :title="alertTitle"
                :reason="alertReason"
                :closed="showTurnOn"
                :full-name="fullName"
              />
              <turnOffAlert
                v-if="showRefusal"
                :title="$t('family_card.turn_off.refusal_main_text')"
                :refusal="family.volunteer_refusal"
                :manage-volunteers="showRefusal"
                :full-name="fullName"
                :has-permission-volunteer-assign="hasPermissionVolunteerAssign && !showTurnOff"
                @assignVolunteer="isManageVolunteers = true"
              />
              <RemoveGiftGiverInfo :giftgiver-info="family.gift_giver_changes" />
              <v-btn
                v-if="isCurrentEdition && isFamilyDisabled && hasPermissionIncludeFamily"
                block
                color="sz_transparent"
                :class="[{ 'responsive-btn-text': xsScreen }]"
                @click="showTurnOnDialog"
              >
                <v-icon
                  :color="$vuetify.theme.sz_green"
                  class="mr-1 fab-links bg_green"
                  :width="16"
                  :height="16"
                >
                  check
                </v-icon>
                {{ $t('buttons.turn_on') }}
              </v-btn>
              <turnOnModal
                :visible="turnOnDialog"
                :family-id="familyId"
                @close="turnOnDialog = false"
              />
            </v-flex>
            <v-layout :wrap="xsScreen">
              <v-flex
                xs12
                class="mt-4"
              >
                <baseFamilyData
                  :to-accept-for-vulunteer="toAcceptForVolunteer"
                  :has-permission-change-wio="hasPermissionChangeWio"
                  @reload="loadFamily(true)"
                />
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              class="mt-4"
            >
              <v-expansion-panel
                v-model="opened.volo"
                class="v-expansion-panel_inlined"
              >
                <v-expansion-panel-content>
                  <template slot="header">
                    <v-layout align-center>
                      <baseIcon
                        :width="36"
                        :height="36"
                        class="mr-3"
                      >
                        <volunteersIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                      </baseIcon>
                      {{ $t('family_card.accordion_titles.volunteers') }}
                    </v-layout>
                  </template>
                  <v-card>
                    <v-divider />
                    <volunteersInfo
                      :has-permission-volunteer-assign="
                        hasPermissionVolunteerAssign && !showTurnOff
                      "
                      :primary-volunteer="family.primary_volunteer"
                      :secondary-volunteer="family.secondary_volunteer"
                      :region-leader="family.wio_struct_leaders"
                      :is-disabled="isFamilyDisabled"
                      :can-be-excluded="family.status.can_be_excluded"
                      @assignVolunteer="isManageVolunteers = true"
                    />
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex
              xs12
              class="mt-4"
            >
              <v-expansion-panel
                v-model="opened.enteranse"
                class="v-expansion-panel_inlined"
              >
                <v-expansion-panel-content>
                  <template slot="header">
                    <v-layout align-center>
                      <baseIcon
                        :width="36"
                        :height="36"
                        class="mr-3"
                      >
                        <folderIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                      </baseIcon>
                      {{ $t('family_card.accordion_titles.enteranse_data') }}
                    </v-layout>
                  </template>
                  <v-card>
                    <v-divider />
                    <enteranseInfo
                      :support-criteria="family.support_criteria"
                      :reporter="family.reporter"
                      :source="family.source"
                      :description="family.description"
                      :previous-editions="family.previous_editions"
                      :family-to-accept-edition="family.family_to_accept_edition"
                      :edition="family.edition"
                      :consent-files="family.initial_consent_files"
                      :particip-prev-edition="family.is_checked && family.is_connected !== true"
                      :from-office="family.from_office"
                      :is-checked="family.is_checked === true || family.is_connected === true"
                    />
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex
              xs12
              class="mt-4"
            >
              <v-expansion-panel
                v-model="opened.documents"
                class="v-expansion-panel_inlined"
              >
                <v-expansion-panel-content>
                  <template slot="header">
                    <v-layout align-center>
                      <p class="mb-0 mr-2">
                        {{ $t('family_card.accordion_titles.documents_list') }}
                      </p>
                      <v-flex
                        v-if="family.has_footprint"
                        class="none-growth"
                      >
                        <FamilyCheckedMark
                          :tooltip="checkMarkText(family.status.family_edition_status_id)"
                        />
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-card>
                    <v-divider />
                    <documentsList
                      :family-id="familyId"
                      :family-status="family.status"
                      :edition="family.edition"
                      :is-checked="family.is_checked === true || family.is_connected === true"
                    />
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex
              v-if="family.edition.edition_id !== editionsId.EDITION_2019"
              xs12
              class="mt-4 mb-4"
            >
              <v-expansion-panel
                v-model="opened.statusChanges"
                class="v-expansion-panel_inlined"
              >
                <v-expansion-panel-content>
                  <template slot="header">
                    <v-layout align-center>
                      {{ $t('family_card.changelog.title') }}
                    </v-layout>
                  </template>
                  <v-card>
                    <v-divider />
                    <familyChangeLog :changes-list="family.changelogs" />
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex
              v-if="family.status.can_be_excluded"
              xs12
              class="mt-4 mb-5"
            >
              <v-btn
                v-if="isCurrentEdition && !showTurnOff"
                block
                color="sz_transparent"
                :class="[{ 'responsive-btn-text': xsScreen }]"
                @click="showDialog"
              >
                <v-icon small>
                  clear
                </v-icon>
                {{ $t('buttons.turn_off') }}
              </v-btn>
              <turnOffModal
                :visible="dialog"
                :family-id="familyId"
                :additional-field="!isNotAttributed"
                :reasons-id="reasonsId"
                @close="dialog = false"
              />
            </v-flex>
          </v-flex>
        </v-layout>
        <v-flex class="none-growth footer-wrap">
          <div class="page-content-paddings">
            <AppFooter class="mb-3" />
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <manageVolunteersDialog
      :item="family"
      :show="isManageVolunteers"
      @reload="loadFamily(true)"
      @show="isManageVolunteers = $event"
    />
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import listPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import baseFamilyData from '@/components/familyCard/BaseFamilyData';
import baseIcon from '@/icons/BaseIcon';
import volunteersIcon from '@/icons/VolunteersIcon';
import folderIcon from '@/icons/FolderIcon';
import volunteersInfo from '@/components/familyCard/VolunteersInfo';
import enteranseInfo from '@/components/familyCard/EnteranseInfo';
import documentsList from '@/components/familyCard/DocumentsList';
import turnOffAlert from '@/components/familyCard/TurnOffAlert';
import AppFooter from '@/components/widgets/AppFooter';
import turnOffModal from '@/components/familyCard/TurnOffModal';
import turnOnModal from '@/components/familyCard/TurnOnModal';
import manageVolunteersDialog from '@/components/widgets/dataTable/manageVolunteersDialog';
import RemoveGiftGiverInfo from '@/components/giftgiver/RemoveGiftGiverInfo';
import Permissions from '@/constants/permissions';
import familyChangeLog from '@/components/familyCard/familyChangeLog';
import FamilyCheckedMark from '@/components/widgets/audit/FamilyCheckedMark';

import statusesId from '@/constants/statusesId';
import editionsId from '@/constants/editionsId';

import familyCheckMarkText from '@/mixins/familyCheckMarkText';
import PreviousEditionDuplicateAlert from '@/components/familyCard/previousEditionDuplicateAlert';
import PageLoader from '@/components/widgets/PageLoader';

export default {
    name: 'FamilyCardPage',
    components: {
        PageLoader,
        PreviousEditionDuplicateAlert,
        familyChangeLog,
        manageVolunteersDialog,
        MainMenu,
        listPagesHeader,
        baseFamilyData,
        baseIcon,
        volunteersIcon,
        folderIcon,
        volunteersInfo,
        enteranseInfo,
        documentsList,
        AppFooter,
        turnOffModal,
        turnOffAlert,
        turnOnModal,
        RemoveGiftGiverInfo,
        FamilyCheckedMark
    },
    mixins: [familyCheckMarkText],
    beforeRouteEnter (to, from, next) {
        if (from.name === 'search-results-qualified' || from.name === 'search-results') {
            localStorage.setItem('fromSearch', 'true');
        }
        next((vm) => {
            vm.$store.dispatch('auth/permissionGuard', [
                Permissions.FAMILY_EDITION_VIEW,
                Permissions.ASSIGNED_FAMILY_EDITION_VIEW
            ]);
            vm.$store.dispatch('sheet/getSheetPermissions', vm.$route.params.id);
            vm.$store.dispatch('giftgiver/getGiftgiverCreators');
        });
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit('family/setFamily', null);
        this.$store.commit('familyData/clearFormData');
        this.$store.commit('giftgiver/resetGiftgiverData');
        localStorage.removeItem('fromSearch');
        next();
    },
    props: {
        previousRouteName: {
            required: false
        }
    },
    data () {
        return {
            statusesId,
            editionsId,
            dialog: false,
            turnOnDialog: false,
            isManageVolunteers: false,
            isDonorVisible: false,
            opened: {
                volo: 0,
                enteranse: 0,
                documents: 0,
                statusChanges: 0
            },
            pageTitle: '',
            hasPermissionVolunteerAssign: false,
            hasPermissionIncludeFamily: false,
            hasPermissionChangeWio: false
        };
    },
    computed: {
        showPageLoader () {
            return this.family == null;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        featuresVisible () {
            return this.$store.getters.featuresVisible;
        },
        urlId () {
            return this.$route.params.id;
        },
        familyId () {
            return this.family.family_edition_id;
        },
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isNotAttributed () {
            return this.family.status.family_edition_status_id === this.statusesId.NOT_ATTRIBUTED;
        },
        deprecatedTurnOffBox () {
            return [
                this.statusesId.STATUS_FINISHED_SUMMARY,
                this.statusesId.STATUS_FURTHER_STORY
            ].includes(this.family.status.family_edition_status_id);
        },
        turnOff () {
            return (
                (this.family.pre_exclusion_status &&
          this.family.pre_exclusion_status.family_edition_status_id) ||
        false
            );
        },
        turnOn () {
            return (
                this.family.status.family_edition_status_id !== this.statusesId.DISABLED &&
        this.family.inclusion_reasons.length > 0
            );
        },
        reasonsId () {
            return this.family.status.family_edition_status_id === this.statusesId.NOT_ATTRIBUTED ? 3 : 1;
        },
        xsScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        showRefusal () {
            return this.family.primary_volunteer === null && this.family.volunteer_refusal.length > 0;
        },
        showTurnOff: {
            get: function () {
                return this.turnOff;
            },
            set: function (val) {
                this.turnOff = val;
            }
        },
        showTurnOn: {
            get: function () {
                return this.turnOn;
            },
            set: function (val) {
                this.turnOn = val;
            }
        },
        alertTitle () {
            if (this.showTurnOff) {
                return this.$t('family_card.turn_off.turn_off_text');
            } else if (this.showTurnOn) {
                return this.$t('family_card.turn_off.turn_on_text');
            }
            return '';
        },
        alertReason () {
            if (this.showTurnOff) {
                return this.family.exclusions;
            } else if (this.showTurnOn) {
                return this.family.inclusion_reasons;
            }
            return '';
        },
        fullName () {
            const _name = this.family.first_name === null ? '' : this.family.first_name + ' ';
            return _name + this.family.last_name;
        },
        toAcceptForVolunteer () {
            return (
                !this.family.is_accepted &&
        this.family.primary_volunteer !== null &&
        this.family.status.family_edition_status_id !== this.statusesId.DISABLED
            );
        },
        isFamilyDisabled () {
            return this.family.status.family_edition_status_id === this.statusesId.DISABLED;
        },
        previousEditionsAlertVisibility () {
            const previousFamily =
        this.family.previous_editions.length > 0 &&
        this.family.previous_editions.find((el) => el.edition === this.family.edition.name);
            let previousFamilyIsDisabled = false;
            if (previousFamily) {
                previousFamilyIsDisabled =
          previousFamily.status.family_edition_status_id === this.statusesId.DISABLED;
            }
            const isDisabled =
        this.family.status.family_edition_status_id === this.statusesId.DISABLED ||
        previousFamilyIsDisabled;

            return this.family.is_glued && !isDisabled;
        }
    },
    watch: {
        family: function (val) {
            if (val != null) {
                this.pageTitle = this.$t('family_card.title') + ': ' + val.last_name;
            }
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', Permissions.VOLUNTEER_ASSIGN).then((result) => {
            this.hasPermissionVolunteerAssign = result;
        });
        this.$store
            .dispatch('auth/hasPermission', Permissions.FAMILY_EDITION_INCLUDE)
            .then((result) => {
                this.hasPermissionIncludeFamily = result;
            });
        this.$store
            .dispatch('auth/hasPermission', Permissions.FAMILY_EDITION_CHANGE_WIO_STRUCT)
            .then((result) => {
                this.hasPermissionChangeWio = result;
            });

        this.loadFamily();
    },
    methods: {
        loadFamily (reload = false) {
            if (!reload) {
                this.$store.commit('family/setFamily', null);
            }

            this.fetchFamily();
        },
        fetchFamily () {
            this.$store
                .dispatch('family/getFamily', { id: this.urlId, endpointLabel: 'family' })
                .then(() => {
                    this.$store.commit(
                        'giftgiver/mergeGiftgiverData',
                        this.$store.getters['family/getFamily'].gift_giver
                    );
                    this.$store.dispatch('audit/getAllAuditComments');
                });
        },
        forward () {
            if (!this.isCurrentEdition) {
                return;
            }
            if (localStorage.getItem('fromSearch')) {
                this.$router.go(-1);
                return;
            }
            if (this.family.is_accepted) {
                this.$router.push({ name: 'families-list' });
            } else {
                this.$router.push({ name: 'families-to-accept' });
            }
        },
        showDialog () {
            this.dialog = true;
        },
        showTurnOnDialog () {
            this.turnOnDialog = true;
        },
        hideTurnOnDialog () {
            this.turnOnDialog = false;
        }
    }
};
</script>
